/*
 * <cart-complementary-products>
 *
 * Populates the cart / minicart upsell with the "complementary products"
 * configured in the Search & Discovery app for the products currently in
 * the cart.
 *
 * For each product in the cart it fetches the cart-complementary section
 * through the Product Recommendations API (intent=complementary), collects
 * the returned items, removes duplicates and any product already in the
 * cart, and renders up to `data-max` items (default 3) using the existing
 * upsell design. If nothing is found, the element stays hidden.
 */
if (!customElements.get('cart-complementary-products')) {
  customElements.define(
    'cart-complementary-products',
    class CartComplementaryProducts extends HTMLElement {
      connectedCallback() {
        this.container = this.querySelector('.js-cart-complementary-container');
        this.baseUrl = this.dataset.baseUrl;
        this.sectionId = this.dataset.sectionId;
        this.intent = this.dataset.intent || 'complementary';
        this.fetchLimit = this.dataset.fetchLimit || 10;
        this.max = parseInt(this.dataset.max, 10) || 3;
        this.cartProductIds = (this.dataset.cartProductIds || '')
          .split(',')
          .map(function (id) { return id.trim(); })
          .filter(Boolean);

        if (!this.container || !this.baseUrl || this.cartProductIds.length === 0) {
          return;
        }

        this.load();
      }

      buildUrl(productId) {
        return (
          this.baseUrl +
          '?section_id=' + encodeURIComponent(this.sectionId) +
          '&product_id=' + encodeURIComponent(productId) +
          '&limit=' + encodeURIComponent(this.fetchLimit) +
          '&intent=' + encodeURIComponent(this.intent)
        );
      }

      load() {
        var self = this;
        var seen = {};
        var collected = [];

        // Fetch complementary products for every cart product in parallel,
        // then merge results preserving cart order.
        var requests = this.cartProductIds.map(function (productId) {
          return fetch(self.buildUrl(productId))
            .then(function (response) { return response.text(); })
            .then(function (text) {
              var holder = document.createElement('div');
              holder.innerHTML = text;
              return holder.querySelectorAll('.product-form__upsell-item--outer');
            })
            .catch(function (error) {
              console.log('cart-complementary error', error);
              return [];
            });
        });

        Promise.all(requests).then(function (results) {
          results.forEach(function (items) {
            items.forEach(function (item) {
              if (collected.length >= self.max) { return; }

              var productId = item.dataset.productId;

              if (!productId) { return; }
              // Skip products already in the cart.
              if (self.cartProductIds.indexOf(productId) !== -1) { return; }
              // Skip duplicates across the different cart products.
              if (seen[productId]) { return; }

              seen[productId] = true;
              collected.push(item);
            });
          });

          self.render(collected);
        });
      }

      render(items) {
        if (!items.length) { return; }

        this.container.innerHTML = '';
        var self = this;
        items.forEach(function (item) {
          self.container.appendChild(item);
        });

        this.style.display = '';
        this.bindEvents();

        // Re-init quickview for products with multiple variants.
        if (window.WAU && WAU.Quickshop && typeof WAU.Quickshop.init === 'function') {
          WAU.Quickshop.init();
        }
      }

      bindEvents() {
        var buttons = this.container.querySelectorAll('.js-upsell-submit');
        buttons.forEach(function (element) {
          element.addEventListener('click', function (e) {
            e.preventDefault();

            var id = parseInt(element.dataset.variantId, 10);
            var configEl = document.getElementById('cart-config');
            var config = configEl ? JSON.parse(configEl.innerHTML || '{}') : {};

            if (!window.WAU || !WAU.ThemeCart) { return; }

            WAU.ThemeCart.addItem(id, 1).then(function () {
              WAU.ThemeCart.getCart().then(function (Cart) {
                WAU.AjaxCart.updateView(config, Cart);
              });
            });
          });
        });
      }
    }
  );
}
